// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__kN201","Link":"StickyAlert_Link__VW+-v","CloseButton":"StickyAlert_CloseButton__NgTfp"};